// Google Apps Script web-app URL that appends "Notify Me" signups to a Google
// Sheet. Setup steps: integrations/notify-sheet/README.md.
// It is safe to commit — the script only accepts new signups, it never reads them back.
export const NOTIFY_ENDPOINT = "https://script.google.com/macros/s/AKfycbyz853CVDCxxKgZzK9Q02WgTQGtgv2rcttHXfcF7JrcqsaTA2fC5m85ps2Ojsq7gQ/exec";
